import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=6f58fedd&scoped=true&"
import script from "./EventView.vue?vue&type=script&lang=ts&"
export * from "./EventView.vue?vue&type=script&lang=ts&"
import style0 from "./EventView.vue?vue&type=style&index=0&id=6f58fedd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f58fedd",
  null
  
)

export default component.exports